//import { Switch } from "@material-ui/core";
//import { createMuiTheme } from "@material-ui/core/styles";
import { createTheme } from '@material-ui/core/styles';
import "../assets/colors.css";

export const lightTheme = createTheme({
    overrides: {
        //Buttons
        MuiButton: {
            root: {
                borderRadius: 0,
                /*Hero Button*/
                "&.besys-button--hero": {
                    background: `var(--btn-hero-bg-gradient)`,
                    color: `var(--btn-hero-text-color)`,
                    padding: `10px`,
                    fontSize: `1rem`,

                    "&.besys-button--hero:hover": {
                        background: `var(--btn-hero-bg-hover)`
                    },

                    "&.besys-button--hero:focus": {
                        background: `var(--btn-hero-bg-active)`
                    },
                },
                /*Primary Button*/
                "&.e-performance-button--primary": {
                    background: `var(--btn-primary-bg-color)`,
                    color: `var(--btn-primary-text-color)`,
                    padding: `10px`,

                    "&.e-performance-button--primary:hover": {
                        background: `var(--btn-primary-bg-hover)`
                    },

                    "&.e-performance-button--primary:focus": {
                        background: `var(--btn-primary-bg-active)`
                    },
                },
                /*Secondary Button*/
                "&.besys-button--secondary": {
                    background: `var(--btn-secondary-bg-color)`,
                    color: `var(--btn-secondary-text-color)`,
                    border: `1px solid var(--blue-green)`,
                    padding: `10px`,

                    "&.besys-button--secondary:hover": {
                        background: `var(--btn-secondary-bg-color-hover)`,
                        color: `var(--btn-secondary-text-color-hover)`
                    },

                    "&.besys-button--secondary:focus": {
                        background: `var(--btn-secondary-bg-color-active)`,
                        color: `var(--btn-secondary-text-color-active)`
                    },
                },
                /*tertiary Button*/
                "&.e-performance-button--tertiary": {
                    background: `var(--btn-tertiary-bg-color)`,
                    color: `var(--btn-tertiary-text-color)`,
                    padding: `10px`,

                    "&.e-performance-button--tertiary:hover": {
                        background: `var(--btn-tertiary-bg-color-hover)`,
                        color: `var(--btn-tertiary-text-color-hover)`
                    },

                    "&.e-performance-button--tertiary:focus": {
                        background: `var(--btn-tertiary-bg-color-active)`,
                        color: `var(--btn-tertiary-text-color-active)`
                    },
                },
            },
            iconSizeMedium: {
                '& > :first-child': {
                    fontSize: '3rem',
                }
            }
        },
        //Label and Input
        MuiFormLabel: {
            root: {
                color: `var(--dark-blue)`,

                "&$focused": {
                    color: `var(--dark-blue)`,
                }
            }
        },
        MuiSelect: {
            select: {
                color: `var(--select-text-color)`,

                "&:focus": {
                    backgroundColor: `var(--transparent)`,
                    color: `var(--select-active-text-color)`,
                    borderTopLeftRadius: `10px`,
                    borderTopRightRadius: `10px`,
                }
            },
            filled: {
                //backgroundColor: `var(--select-bg-color-hover) `
            },
            icon: {
                top: `-4px`
            }
        },

        MuiListItem: {
            root: {
                "&.Mui-selected": {
                    backgroundColor: `var(--select-list-item-bg-color)`
                },
                "&&&&:hover": {
                    backgroundColor: `var(--select-list-item-bg-color)`
                }
            }
        },
        MuiPaper: {
            rounded: {
                backgroundColor: `var(--sky-blue)`
            }
        },
        MuiToolbar: {
            root: {
                backgroundColor: `var(--petrol-green)`,
                "&.reports": {
                    backgroundColor: `var(--dark-blue)`,
                    color: `var(--white)`,

                }
            },
        },
        MuiTypography: {
            h6: {
                color: `var(--dark-blue)`
            }
        },
        MuiTableCell: {
            head: {
                padding: `0px !important`,
                paddingBottom: `0.5rem !important`,
                paddingRight: `10px !important`,
                backgroundColor: `var(--petrol-green) !important`,
                fontSize: `1rem`,
                lineHeight: `1rem`
            },
            root: {
               // padding: `8px !important`,
            },
            h6: {
                color: `#000028 !important`
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: `0px`,
                borderTopRightRadius: `0px`,
                backgroundColor: `var(--input-bg-color)`,
                "&&&&:focus": {
                    backgroundColor: `var(--input-bg-color-focus)`
                },
                "&&&&:hover": {
                    backgroundColor: `var(--input-bg-color-hover)`
                },
                "&$disabled": {
                    color: `var(--disable-text-color)`,
                    cursor: 'no-drop',
                }
                //"&.Mui-error": {
                //    backgroundColor: `var(--error-red-bg-color)`,
                //    color: `var(--error-red--color)`,

                //    "&&&&:hover": {
                //        backgroundColor: `var(--error-red-bg-color)`,
                //    },
                //    "& underline": {
                //        "&&&&:before": {
                //            borderBottom: `1px solid var(--error-red--color)`
                //        },
                //        "&&&&:after": {
                //            borderBottom: `2px solid var(--error-red--color)`
                //        },
                //    }
                //}
            },
            underline: {
                "&&&&:before": {
                    borderBottom: `1px solid #00B3B3`
                },
                "&&&&:after": {
                    borderBottom: `2px solid #00B3B3`
                },
            },
            input: {
                backgroundColor: `var(--input-bg-color-focus)`,
                "&&&&:focus": {
                    backgroundColor: `var(--input-bg-color-focus)`,
                },
                "&&&&:hover": {
                    backgroundColor: `var(--light-color-hover)`,
                },
            }
        },
        MuiAutocomplete: {
            root: {
                borderTopLeftRadius: `0px`,
                borderTopRightRadius: `0px`,
                //backgroundColor: `#00CCCC2F`,
                "&&&&:focus": {
                    backgroundColor: `var(--input-bg-color-focus)`
                },
                "&&&&:hover": {
                    backgroundColor: `var(--input-bg-color-hover)`
                },
                "&$disabled": {
                    color: `var(--disable-text-color)`,
                    cursor: 'no-drop',
                }
                //"&.Mui-error": {
                //    backgroundColor: `var(--error-red-bg-color)`,
                //    color: `var(--error-red--color)`,

                //    "&&&&:hover": {
                //        backgroundColor: `var(--error-red-bg-color)`,
                //    },
                //    "& underline": {
                //        "&&&&:before": {
                //            borderBottom: `1px solid var(--error-red--color)`
                //        },
                //        "&&&&:after": {
                //            borderBottom: `2px solid var(--error-red--color)`
                //        },
                //    }
                //}
            },
        },
        MuiTextField: {
            root: {
                borderTopLeftRadius: `0px`,
                borderTopRightRadius: `0px`,
                backgroundColor: `#00CCCC2F`,
                "&&&&:focus": {
                    backgroundColor: `var(--input-bg-color-focus)`
                },
                "&&&&:hover": {
                    backgroundColor: `var(--input-bg-color-hover)`
                },
                "&$disabled": {
                    color: `var(--disable-text-color)`,
                    cursor: 'no-drop',
                }
                //"&.Mui-error": {
                //    backgroundColor: `var(--error-red-bg-color)`,
                //    color: `var(--error-red--color)`,

                //    "&&&&:hover": {
                //        backgroundColor: `var(--error-red-bg-color)`,
                //    },
                //    "& underline": {
                //        "&&&&:before": {
                //            borderBottom: `1px solid var(--error-red--color)`
                //        },
                //        "&&&&:after": {
                //            borderBottom: `2px solid var(--error-red--color)`
                //        },
                //    }
                //}
            },
        },
        //MuiTablePagination: {
        //    toolbar: {
        //        backgroundColor: `var(--sky-blue)`
        //    }
        //},
        //Related Tag - Chips
        MuiChip: {
            outlined: {
                border: `1px solid var(--chips-bg-color)`,
                color: `var(--chips-text-color)`,
                backgroundColor: `var(--white)`,
                "&&&&:hover": {
                    backgroundColor: `var(--chips-bg-color-hover)`,
                    color: `var(--chips-text-color-hover)`,
                }
            }
        },
        //Accordion
        //Tabs
        MuiTab: {
            root: {
                backgroundColor: `var(--white)`,
                color: `var(--dark-blue) !important`,
                textTransform: "none"
            },
            wrapper: {
                fontSize: `1.05rem`
            },
        },
        PrivateTabIndicator: {
            root: {
                borderBottom: `4px solid var(--light-green)`
            },
            colorPrimary: {
                backgroundColor: `transparent`
            }
        },
        //Dialog
        MuiDialog: {
            paper: {
                background: `var(--white)`,
            }
        },
        MuiDialogTitle: {
            root: {
                color: `var(--dark-blue)`,
                textAlign: 'center'
            }
        },
        MuiDialogActions: {
            root: {
                justifyContent: `center`,
                padding: `20px`
            }
        },
        MuiSvgIcon: {
            root: {
                color: `var(--dark-blue)`,
                //background: `var(--bg-gradient)`,
                padding: `10px`,
                borderRadius: `50%`,
                fontSize: `2.5rem`,

            },
            fontSizeSmall: {
                fontSize: `2.8rem`,
                background: `transparent`
            }
        },
        //New by Sachin
        MuiBox: {
            root: {
                padding: `0px`
            }
        },
        MuiTablePagination: {
            root: {
                height: `5.1rem !important`
            },
            toolbar: {
                backgroundColor: `transparent`
            },
            input: {
                paddingRight: `1.5rem`
            },
        },
        MuiAccordion: {
            root: {
                marginBottom: `10px`,
                boxShadow: `0 2px 10px 0 #CCCCCC80`,
                border: `none`,
                width: `100%`,
                "&&&&:before": {
                    backgroundColor: `var(--transparent)`
                }
            }
        },
        MuiAccordionSummary: {
            root: {
                /*backgroundColor: `var(--accordian-active-bg-color)`/,*/
                color: `var(--master-blue)`,
                fontFamily: `SiemensSans-Bold`,
                transition: `0.5s`,
                "&.Mui-expanded": {
                    backgroundColor: `var(--accordian-heading-bg-color-hover)`
                },
                "&&&&:hover": {
                    backgroundColor: `var(--accordian-heading-bg-color-hover) !important`,
                },
                "& .MuiSvgIcon-root": {
                    background: `var(--transparent)`
                }
            }
        },
        MuiAccordionDetails: {
            root: {
                backgroundColor: `#F3F3F6`
            }
        },
        Component: {
            paginationSelectRoot: {
                paddingRight: `1.5rem`
            }
        },
        MuiIconButton: {
            root: {
                background: `transparent !important`
            }
        },
        MuiAlert: {
            icon: {
                fontSize: `2.4rem`
            },
            standardSuccess: {
                color: `#000028`,
                backgroundColor: `#00E6DC`
            },
            standardError: {
                backgroundColor: `#FF545480`
            },
            message: {
                paddingTop: `16px`
            }
        },
        MuiPickersDay: {
            daySelected: {
                color: `var(--red)`
            }
        },
        MuiFormControl: {
            root: {
                borderTopLeftRadius: `0px`,
                borderTopRightRadius: `0px`,
                "&&&&:focus": {
                },
                "&&&&:hover": {
                },
                "&$disabled": {
                    color: `var(--disable-text-color)`,
                    cursor: 'no-drop',
                }
            },
            underline: {
                "&&&&:before": {
                    borderBottom: `1px solid #00B3B3`
                },
                "&&&&:after": {
                    borderBottom: `2px solid #00B3B3`
                },
            },
            input: {
                "&&&&:focus": {
                    backgroundColor: `var(--input-bg-color-focus)`,
                },
                "&&&&:hover": {
                },
            }
        },
        MuiInput: {
            root: {
                borderTopLeftRadius: `0px`,
                borderTopRightRadius: `0px`,
                "&&&&:hover": {
                },
                "&$disabled": {
                    cursor: 'no-drop',
                },
                "&.custom-pd-bottom": {
                    marginBottom: `0.5rem`
                }
            },
            underline: {
                "&&&&:before": {
                    borderBottom: `1px solid #00B3B3`,
                },
                "&&&&:after": {
                    borderBottom: `0px solid #00B3B3`
                },
            },

        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: `var(--blue-green)`
            }
        },
        //Select Dropdown
        //Switch
    }

});
